// extracted by mini-css-extract-plugin
module.exports = {"tab":"Tab_tab__Z2EY2","selected":"Tab_selected__f3xvL","iconTab":"Tab_iconTab__2HW75","iconSelected":"Tab_iconSelected__15od2","disabled":"Tab_disabled__x0Cy7"};